module.exports = __webpack_public_path__ + "static/media/capturecollab-center-color-blue-icon.34c706e2.png";